module.exports = __webpack_public_path__ + "static/media/bg.e6a8d161.jpg";